
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "env": "release",
  "buildInfo": {
    "version": "2.0.0-bridge.1",
    "time": 1784779955245,
    "commit": "e2d51c9f18c46f2cfb095f8fcf9321070ff19f90",
    "shortCommit": "e2d51c9",
    "branch": "release",
    "env": "release"
  },
  "una": {
    "primary": "yellow",
    "gray": "stone",
    "radius": 0.5,
    "fontSize": 16
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/runner/work/next.interviewroom.ai/next.interviewroom.ai/app/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
